import React from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import "./App.css";
import "./portal/portal.css";
import "../src/pages/assessment.css";
import "../src/pages/nutrition.css";
import "../src/pages/online-training.css";
import { Toaster } from "./components/ui/sonner";
import SEOSchema from "./components/SEOSchema";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { MessageCircle } from "lucide-react";

// Pages
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import CorporatePage from "./pages/CorporatePage";
import ResultsPage from "./pages/TestimonialsPage";
import RetreatPage from "./pages/RetreatPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import FreeAssessmentPage from "./pages/AssessmentPage";
import NutritionGuidePage from "./pages/NutritionGuidePage";
import OnlineTrainingPage from "./pages/OnlineTrainingPage";

// Portal
import { AuthProvider } from "./portal/AuthContext";
import LoginPage from "./portal/LoginPage";
import AdminDashboard from "./portal/AdminDashboard";
import ClientDashboard from "./portal/ClientDashboard";
import usePageSEO from "./utils/usePageSEO";

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const isPortal = location.pathname.startsWith('/portal');
  usePageSEO();

  const goToContact = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  if (isPortal) {
    return (
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/portal" element={<LoginPage />} />
          <Route path="/portal/admin" element={<AdminDashboard />} />
          <Route path="/portal/dashboard" element={<ClientDashboard />} />
        </Routes>
      </AuthProvider>
    );
  }

  return (
    <div className="app">
      <SEOSchema />
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage onContactClick={goToContact} />} />
          <Route path="/services" element={<ServicesPage onContactClick={goToContact} />} />
          <Route path="/corporate" element={<CorporatePage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/retreat" element={<RetreatPage onContactClick={goToContact} />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/free-assessment" element={<FreeAssessmentPage />} />
          <Route path="/nutrition-guide" element={<NutritionGuidePage />} />
          <Route path="/online-training" element={<OnlineTrainingPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
      
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/447787166065?text=Hi%20Aaron%2C%20I%27d%20like%20to%20enquire%20about%20your%20services"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Contact on WhatsApp"
        data-testid="whatsapp-float-btn"
      >
        <MessageCircle size={28} />
      </a>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
